import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  getMemberInfo,
  selectMemberInfo,
  getDocumentFile,
  getDocumentLinks,
} from "../../../state/ducks/member/index";
import { alertActions } from "../../../state/ducks/alert/index";
import EminevimLoading from "../shared/EminevimLoading";

class MemberInfo extends Component {
  state = {
    isLoading: true,
    memberNoFilter: "",
    shouldAnimateCards: false,
  };

  componentDidMount() {
    this.props
      .getMemberInfo()
      .finally(() => {
        this.setState({ isLoading: false, shouldAnimateCards: true });
        window.setTimeout(() => this.setState({ shouldAnimateCards: false }), 1200);
      });
  }

  normalizeMemberNo = (value) => String(value || "").replace(/\D/g, "");

  matchesMemberNoFilter = (item, filter) => {
    const trimmedFilter = (filter || "").trim();
    if (!trimmedFilter) return true;

    const normalizedFilter = this.normalizeMemberNo(trimmedFilter);
    const normalizedMemberNo = this.normalizeMemberNo(item.uyeNo);
    return normalizedMemberNo.includes(normalizedFilter);
  };

  getFilteredMembers = () => {
    const { member } = this.props;
    const { memberNoFilter } = this.state;

    if (!member?.info) return [];

    return member.info.filter((item) => this.matchesMemberNoFilter(item, memberNoFilter));
  };

  handleMemberNoFilterChange = (event) => {
    this.setState({ memberNoFilter: event.target.value });
  };

  clearMemberNoFilter = () => {
    this.setState({ memberNoFilter: "" });
  };

  renderMemberNoFilter = () => (
    <div className="t-memberInfo-filterBar">
      
      <div className="t-memberInfo-filterInputWrap">
        <i className="t-icon-search" aria-hidden="true" />
        <input
          id="memberNoFilter"
          type="text"
          className="t-memberInfo-filterInput"
          placeholder="Üye numarasına göre filtrele"
          value={this.state.memberNoFilter}
          onChange={this.handleMemberNoFilterChange}
        />
        {this.state.memberNoFilter && (
          <button
            type="button"
            className="t-memberInfo-filterClear"
            onClick={this.clearMemberNoFilter}
            aria-label="Filtreyi temizle"
          >
            &times;
          </button>
        )}
      </div>
    </div>
  );

  renderMemberInfoLoading = () => (
    <EminevimLoading subtext="Üyelik bilgileriniz hazırlanıyor, lütfen bekleyiniz." />
  );

  getDocumentFile = (documentId) => {
    if (documentId === null) {
      this.props.showError(
        "Sözleşmeniz henüz yüklenmemiştir. Müşteri temsilcinizle görüşebilirsiniz."
      );
    } else {
      this.props.getDocumentLink(documentId);
    }
  };

  getMemberThemeClass = (orgTurId) => {
    if (orgTurId === 2) return "t-memberDetail-header--green";
    if (orgTurId === 3) return "t-memberDetail-header--orange";
    if (orgTurId === 1) return "t-memberDetail-header--blue";
    return "t-memberDetail-header--blue";
  };

  renderMemberIcon = (item) => {
    if (item.orgTurId === 2) {
      return <i className="t-icon-home1" aria-hidden="true" />;
    }

    if (item.orgTurId === 3) {
      return (
        <img
          src="/assets/img/svg/icon_kabe.svg"
          alt=""
          className="t-memberDetail-headerKabeIcon"
        />
      );
    }

    return <i className="t-icon-truck1" aria-hidden="true" />;
  };

  canOpenMemberDetail = (item) => {
    return (item.kaynak === 2 && item.statu === 6) || item.kaynak !== 2;
  };

  showContractButton = (item) => {
    return item.statu !== null && (item.statu === 3 || item.statu === 6);
  };

  renderSummaryField = (label, value, options = {}) => {
    const { hidden = false, danger = false } = options;

    if (hidden) return null;

    return (
      <div className="t-memberInfo-summaryItem">
        <span className="t-memberInfo-summaryLabel">{label}</span>
        <span className={`t-memberInfo-summaryValue${danger ? " t-memberInfo-summaryValue--danger" : ""}`}>
          {value}
        </span>
      </div>
    );
  };

  getMemberTypeLabel = (orgTurId) => {
    if (orgTurId === 2) return "Ev";
    if (orgTurId === 3) return "Hac";
    return "Araç";
  };

  renderMemberCard = (item, index, shouldAnimateCards) => {
    const hac = item.orgTurId === 3;
    const themeClass = this.getMemberThemeClass(item.orgTurId);
    const showPlannedDeliveryDate = item.kayitTuruId !== 10 && item.kayitTuruId !== 11;
    const showInstallmentDeferral =
      item.kayitTuruId !== 8 &&
      item.dondurulanAy !== "0" &&
      item.dondurulanAy !== null &&
      item.dondurulanAy !== 0;
    const showGroupOrDeferralRow =
      item.grupNo !== null ||
      (item.kayitTuruId !== 8 && showInstallmentDeferral);

    return (
      <article
        className={`t-memberInfo-card${shouldAnimateCards ? " t-memberInfo-card--enter" : ""} ${themeClass}`}
        key={item.id}
        style={shouldAnimateCards ? { animationDelay: `${index * 80}ms` } : undefined}
      >
        <div className="t-memberInfo-cardAccent" aria-hidden="true" />

        <div className="t-memberInfo-cardInner">
          <div className="t-memberInfo-cardHeader">
            <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
              {this.renderMemberIcon(item)}
            </div>

            <div className="t-memberInfo-cardHeaderContent">
              <div className="t-memberInfo-cardTitleRow">
                <h2 className="t-memberInfo-cardTitle">{item.orgSis}</h2>
                <span className="t-memberInfo-typeChip">{this.getMemberTypeLabel(item.orgTurId)}</span>
              </div>
              <div className="t-memberInfo-cardBadges">
                <span className="t-memberInfo-memberNoBadge">
                  <i className="t-icon-user" aria-hidden="true" />
                  Üye No:&nbsp;
                  <NumberFormat
                    decimalSeparator={false}
                    thousandSeparator={"."}
                    value={item.uyeNo}
                    displayType={"text"}
                  />
                </span>
                <span
                  className={`t-memberInfo-kayitBadge${
                    item.kayitTuruId === 8 ? " t-memberInfo-kayitBadge--danger" : ""
                  }`}
                >
                  {item.kayitTuru}
                </span>
              </div>
            </div>

            <div className="t-memberInfo-cardActions">
            {this.showContractButton(item) && (
              <button
                type="button"
                className="t-memberInfo-btn t-memberInfo-btn--secondary"
                onClick={() => this.getDocumentFile(item.dokumanId)}
              >
                <i className="t-icon-document-alt-stroke" aria-hidden="true" />
                <span>Sözleşme</span>
              </button>
            )}

            {this.canOpenMemberDetail(item) ? (
              <Link
                to={`/Home/MemberDetail/${item.id}`}
                className="t-memberInfo-btn t-memberInfo-btn--primary"
              >
                <span>Detaylar</span>
                <i className="t-icon-arrow-right2" aria-hidden="true" />
              </Link>
            ) : (
              <span className="t-memberInfo-btn t-memberInfo-btn--disabled">
                <span>Detaylar</span>
                <i className="t-icon-arrow-right2" aria-hidden="true" />
              </span>
            )}
          </div>
        </div>

          <div className="t-memberInfo-cardSummary">
            {this.renderSummaryField(
              "Organizasyon Tutarı",
              <NumberFormat
                decimalSeparator={","}
                thousandSeparator={"."}
                suffix={hac ? " XAU" : " ₺"}
                value={item.orgTutar}
                displayType={"text"}
              />
            )}
            {item.kayitTuruId !== 8 &&
              this.renderSummaryField(
                showPlannedDeliveryDate ? "Planlanan Teslim" : "Teslim Tarihi",
                item.teslimTarihi || "-"
              )}
            {this.renderSummaryField("Başlangıç Tarihi", item.baslangicTarihi)}
            {showGroupOrDeferralRow &&
              this.renderSummaryField("Grup No", item.grupNo, { hidden: item.grupNo === null })}
            {showGroupOrDeferralRow &&
              this.renderSummaryField("Taksit Erteleme", `${item.dondurulanAy} Ay`, {
                hidden: !showInstallmentDeferral,
              })}
            {this.renderSummaryField("Ayrılma Tarihi", item.ayrilmaTarihi, {
              hidden:
                item.kayitTuruId !== 8 ||
                item.ayrilmaTarihi === null ||
                item.ayrilmaTarihi === "",
            })}
          </div>

        {item.cekilisSiraNo !== null && (
          <div className="t-memberInfo-drawBar">
            <span>Grup No: <strong>{item.cekilisGrupNo ?? "-"}</strong></span>
            <span>Sıra No: <strong>{item.cekilisSiraNo ?? "-"}</strong></span>
            <span>Çekiliş Tarihi: <strong>{item.cekilisTarih ?? "-"}</strong></span>
          </div>
        )}

        {item.kayitTuruId === 12 && (
          <div className="t-memberInfo-notice">
            Ayrılma süreciniz sonlanana kadar üyeliğinize devam etme hakkınız bulunmaktadır.
            Devam etme düşünceniz yok ise ödeme yükümlülüğünüz bulunmamaktadır.
          </div>
        )}
        </div>
      </article>
    );
  };

  render() {
    const { member } = this.props;
    const { isLoading, memberNoFilter, shouldAnimateCards } = this.state;
    const filteredMembers = this.getFilteredMembers();

    return (
      <div className="t-memberInfo-page" style={{ background: "#ffffff" }}>
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Üyelik Bilgilerim</h1>
              <p className="t-memberInfo-pageSubtitle">
                Aktif üyeliklerinizi görüntüleyin ve detay sayfasına geçin.
              </p>
            </div>

            {isLoading ? (
              this.renderMemberInfoLoading()
            ) : (
              <>
                {this.renderMemberNoFilter()}
                {filteredMembers.length > 0 ? (
                  <>
                    <div className="t-memberInfo-listMeta">
                      <span>{filteredMembers.length} üyelik listeleniyor</span>
                    </div>
                    <div className="t-memberInfo-list">
                    {filteredMembers.map((item, index) =>
                      this.renderMemberCard(item, index, shouldAnimateCards && !memberNoFilter)
                    )}
                  </div>
                  </>
                ) : (
                  <div className="t-memberInfo-emptyFilter">
                    {memberNoFilter
                      ? "Aradığınız üye numarasına uygun kayıt bulunamadı."
                      : "Görüntülenecek üyelik kaydı bulunmuyor."}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    member: selectMemberInfo(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  getMemberInfo: () => dispatch(getMemberInfo()),
  getDocumentFile: (documentId) => dispatch(getDocumentFile(documentId)),
  getDocumentLink: (documentId) => dispatch(getDocumentLinks(documentId)),
  showError: (message) => dispatch(alertActions.showError(message)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MemberInfo);
